import React, { memo, useContext, useMemo } from 'react'

import { Icon, Text } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { getMultiViewConstraints } from 'Pods/ThreeDStudio/Shared/Utils/getMultiViewConstraints'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { ACTION } from 'Pods/ThreeDStudio/Store/constants'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import MultiViewPreview from './Components/MultiViewPreview/MultiViewPreview'

// The filled multi-view slots the active engine accepts, in the provider's order -
// the same set the uploader shows and the payload sends.
const filledViews = (inputViewImages, inputImageSchema) => (
  getMultiViewConstraints(inputImageSchema).viewTypes
    .filter(viewType => inputViewImages?.[viewType]?.url)
    .map(viewType => ({ viewType, url: inputViewImages[viewType].url }))
)

function ActionPreview() {
  const t = useTranslation()
  const { multiViewEnabled } = useContext(ThreeDStudioPageContext)
  const inputImageUrl = useThreeDStudioStore(state => state.modelSettings.inputImageUrl)
  const isMultiView = useThreeDStudioStore(state => state.modelSettings.isMultiView) && multiViewEnabled
  const inputViewImages = useThreeDStudioStore(state => state.modelSettings.inputViewImages)
  const inputImageSchema = useThreeDStudioStore(
    state => state.schema?.generationModelSchema?.input_schema?.properties?.input_image
  )
  const multiViews = useMemo(
    () => filledViews(inputViewImages, inputImageSchema),
    [inputViewImages, inputImageSchema]
  )
  const prompt = useThreeDStudioStore(state => state.modelSettings.prompt)
  const generationAction = useThreeDStudioStore(state => state.schema.generationAction)
  const isImageTo3D = generationAction === ACTION.IMAGE_TO_3D && !isMultiView
  const isMultiViewTo3D = generationAction === ACTION.IMAGE_TO_3D && isMultiView
  const isTextTo3D = generationAction === ACTION.TEXT_TO_3D

  if (
    (isImageTo3D && !inputImageUrl)
    || (isMultiViewTo3D && multiViews.length === 0)
    || (isTextTo3D && !prompt)
  ) {
    return null
  }

  return (
    <div className="collapsed-model-settings__row">
      <span className="collapsed-model-settings__title">{t('leftSide.actionPreview.title')}</span>
      {isImageTo3D && (
        <img
          src={inputImageUrl}
          alt="Uploaded preview"
          className="collapsed-model-settings__image-preview"
          decoding="async"
        />
      )}
      {isMultiViewTo3D && <MultiViewPreview views={multiViews} />}
      {isTextTo3D && (
        <DesktopOnlyTooltip content={prompt} id="text-to-3d-tooltip" place="right" >
          <span className="collapsed-model-settings__text-icon">
            <Icon svgComponent={Text} color="dark" notSpaced />
          </span>
        </DesktopOnlyTooltip>
      )}
    </div>
  )
}

export default memo(ActionPreview)
